/*
 * Authors: mariushirjanu, Koen
 * Created: 30/10/2015
 * Upgraded: 20/03/2023
 */
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OrderEntryInvoiceService } from './invoice/order-entry-invoice.service';
import { ILocationOption, InvoiceAddressType, OrderEntryAddressTypeExtra } from './order-entry-location-data.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { ILocationExtended } from '../../../../../type_definitions/datatypes';

interface ICommentModel {
  comments:string;
}

@Component({
  selector: 'order-location-comments',
  template: `
    <div class="comments">
      <h2 translate>{{ title }}</h2>
      <div class="row">
        <div class="col-md-12">
          <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true" class="form-horizontal"></formly>
        </div>
      </div>
    </div>
  `
})
export class OrderLocationCommentsComponent implements OnInit {
  @Input() public title:string;
  @Input() public locationToModel:OrderEntryInvoiceService;
  @Input() public addressType:InvoiceAddressType;
  @Input() public location:ILocationExtended;

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:ICommentModel = <any>{};
  public loading:boolean;
  private locationOption:ILocationOption;

  constructor(
    private formlyService:GaFormlyService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.start();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.addressType) {
      this.addressType = changes.addressType.currentValue;
      this.onAddressTypeChange();
    }

    if (changes.location) {
      this.location = changes.location?.currentValue;
      this.locationOption = this.locationToModel.getLocationOption(this.location?.id);

      // do not overwrite the comment when selecting another location
      if (!this.model.comments) {
        this.updateModel(this.locationOption?.comment);
      }
    }
  }

  private start():void {
    this.model.comments = this.locationToModel.comments;
    this.fields = this.createFields();
  }

  private onAddressTypeChange():void {
    // When selected invoice address is 'default invoice address' and it has comments on it
    // Fill commentModel with address' comment if any
    if (this.addressType === OrderEntryAddressTypeExtra.DEFAULT_INVOICE_ADDRESS) {
      this.updateModel(this.locationToModel.getLoadedAddress(this.addressType)?.comment);
    }
  }

  private updateModel(comments:string):void {
    if(comments) {
      this.locationToModel.comments = comments;
      this.form.patchValue({ comments });
    }
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aTextarea('comments', 'GA.GENERAL.COMMENTS')
        .withMaxLength(1000)
        .withoutWrapper()
        .onChange(() => {
          this.updateModel(this.model.comments);
        })
        .build()
    ];
  }
}